import React from 'react';
import { useOutletContext } from 'react-router-dom';

import Banner from '../../Components/Banner/Banner';
import { usePageTitle } from '../../Utils/hooks/usePageTitle';

const Home = () => {
    const { openSignup } = useOutletContext();
    usePageTitle();

    return <Banner onSignUpClick={openSignup} />;
};

export default Home;
